import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {Message, MessageType} from "../api/Models";
import {PURGE} from "redux-persist/es/constants";

// Define a type for the slice state
export interface MessagesState {
  messages: Message[]
}

// Define the initial state using that type
const initialState: MessagesState = {
  messages: [{
    id: '1',
    type: MessageType.Notice,
    entry: "You can 'register' or 'login' to continue or enter 'help' to see all of the possible commands...",
    authorIds: [],
    createdAt: new Date(),
    updatedAt: null
  }]
}

export const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setMessages: (state, action: PayloadAction<Message[]>) => {
      state.messages = action.payload
    },
    addMessage: (state, action: PayloadAction<Message>) => {
      state.messages = [
        ...state.messages,
        action.payload
      ]
    },
    updateMessage: (state, action: PayloadAction<Partial<Message>>) => {
      state.messages = state.messages.filter((m) => {
        if (m.id === action.payload.id) {
          return {
            ...m,
            ...action.payload
          }
        } else {
          return m
        }
      })
    },
    removeMessage: (state, action: PayloadAction<string>) => {
      state.messages = state.messages.filter((e) => e.id !== action.payload)
    }
  }
})

export const { setMessages, addMessage, removeMessage, updateMessage } = messagesSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectMessages = (state: RootState): Message[] => state.messages.messages
export const selectMessage = (state: RootState, id: string): Message|undefined => {
  return state.messages.messages.find((m) => m.id === id)
}

export default messagesSlice.reducer